import React from "react";
import GovernmentSchemeFormPage from "../components/government-schemes/GovernmentSchemeFormPage";

const GovernmentSchemeEdit = () => <GovernmentSchemeFormPage mode="edit" />;

export default GovernmentSchemeEdit;
